import useHomeType from 'hooks/useHomeType'
import styled from 'styled-components'
import { RotaPatternEditForm } from '../RotaPattern'

export const RotaEditVisitsScreen = () => {
  const { hasRota } = useHomeType()

  if (!hasRota) {
    return null
  }

  return (
    <PageContainer>
      <RotaPatternEditForm type="visit" />
    </PageContainer>
  )
}

const PageContainer = styled.div`
  padding: 24px 48px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  max-width: 1080px;
  margin-left: auto;
  margin-right: auto;
`
